import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SettingsContainer from '../components/settings/SettingsContainer';
import SettingsSidebar from '../components/settings/SettingsSidebar';
import { isAdminRole } from '../utils/roleHelpers';

const Settings = ({ user }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'Manage Users');

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
      // Clear navigation state so it doesn't persist on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  const isAdmin = isAdminRole(user?.role);

  return (
    <div className="min-h-screen bg-background py-4 px-2 sm:py-8 sm:px-4 pb-20 md:pb-4">
      <div className="mx-auto bg-card rounded-lg shadow-sm flex flex-col md:flex-row overflow-hidden border border-border">
        <SettingsSidebar
          activeTab={activeTab}
          onTabChange={setActiveTab}
          isAdmin={isAdmin}
        />
        <div className="flex-1 border-t md:border-t-0 md:border-l border-border overflow-x-auto">
          <SettingsContainer initialTab={activeTab} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(Settings);
